<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<lms-query-view-loco-data *ngIf="!hideTable && searchResult && searchType === 'Locomotives'" [loadData]="loadData" (showLocoMenu)='showLocomotiveContextMenu($event);'
    (hideContextPanel)='hideLocoTrainContextPanel($event);'>
</lms-query-view-loco-data>

<lms-query-view-train-data *ngIf="!hideTable && searchResult && searchType === 'Trains'" [loadData]="loadData" (showTrainMenu)='showTrainContextMenu($event)'
    (hideContextPanel)='hideLocoTrainContextPanel($event);'></lms-query-view-train-data>